import React from "react";
import { House, Users, Building2, Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const plans = [{
  id: "gamer",
  title: "Collaborative Groups",
  icon: Users,
  price: "30+",
  description: "Small group dynamics designed to foster peer learning and mathematical discourse.",
  features: ["Collaborative problem solving", "Constructive skill building", "Shared learning milestones", "Teacher facilitated"],
  isHighlighted: true,
  badgeText: "Bring a Classmate",
  buttonText: "Book a Session",
  buttonVariant: "default" as const,
  linkTo: "/TutoringProgramsPage"
}, {
  id: "residential",
  title: "One-on-One Deep Dives",
  icon: House,
  price: "70+",
  description: "Personalized sessions focused on strengthening core concepts and building confidence.",
  features: ["Active student learning", "Certified teaching expertise", "Customized curriculum support", "Flexible virtual scheduling"],
  isHighlighted: true,
  badgeText: "Most Popular",
  buttonText: "Book a Session",
  buttonVariant: "outline" as const,
  linkTo: "/BookASessionPage"
}, {
  id: "business",
  title: "Test Readiness",
  icon: Building2,
  price: "70+",
  description: "Academic support for advanced placement and college readiness.",
  features: ["AP® Precalculus & AP® Calculus", "PSAT®, SAT®, ACT® and others", "Practice tests & score reports", "Focus on understanding"],
  isHighlighted: true,
  buttonText: "Book a Session",
  badgeText: "Test Prep",
  buttonVariant: "outline" as const,
  linkTo: "/MasterTeacherPage"
}];
export default function TailoredConnectivity() {
  return <section data-section-id="246046" id="tailored-learning-paths" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-serif mb-4 text-primary">Tailored Learning</h2>
          <p className="text-lg text-muted-foreground font-default">For building math confidence and understanding</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center pt-4">
          {plans.map((plan, i) => {
          const Icon = plan.icon;
          return <Card key={plan.id} data-index={i} className={`relative flex flex-col h-full transition-all duration-500 rounded-lg ${plan.isHighlighted ? "border-2 border-primary shadow-xl shadow-primary/5 md:-translate-y-4 z-10 bg-gradient-to-b from-white to-accent/30" : "border border-border hover:border-primary/30 hover:shadow-lg hover:bg-gradient-to-br hover:from-white hover:to-accent/20"}`}>
                {plan.isHighlighted && plan.badgeText && <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <Badge variant="default" className="uppercase tracking-widest text-[10px] font-bold px-4 py-1 shadow-md bg-secondary text-secondary-foreground rounded-md">
                      {plan.badgeText}
                    </Badge>
                  </div>}

                <CardHeader className="text-center pb-2">
                  <div className={`mx-auto p-4 rounded-lg mb-4 w-fit transition-colors duration-300 ${plan.isHighlighted ? "bg-primary text-primary-foreground" : "bg-muted text-primary"}`}>
                    <Icon className="w-8 h-8" />
                  </div>
                  <CardTitle className="text-3xl font-serif text-primary">{plan.title}</CardTitle>
                  <CardDescription className="mt-2 h-10 flex items-center justify-center text-muted-foreground font-default">
                    {plan.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="flex-grow text-center pt-4">
                  <div className="mb-6">
                    <span className="text-5xl font-bold font-mono text-primary">
                      ${plan.price}
                    </span>
                    <span className="text-muted-foreground font-mono">/hr</span>
                  </div>
                  <ul className="space-y-3 text-left">
                    {plan.features.map((feature, index) => <li key={index} className="flex items-start gap-3">
                        <Check className={`w-5 h-5 shrink-0 mt-0.5 ${plan.isHighlighted ? "text-secondary" : "text-primary"}`} />
                        <span className="text-sm text-foreground/80 font-default">{feature}</span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>;
        })}
        </div>
        <div className="flex justify-center pt-6">
          <Button asChild variant="outline" size="lg" className="font-semibold rounded-md transition-all duration-300 border-primary text-primary hover:bg-primary/5">
            
          </Button>
        </div>
      </div>
    </section>;
}